import { type AxiosRequestConfig } from 'axios'

const getUserJobList = (id?: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: id ? `/users/${id}/info/job/list` : '/user/info/job/list'
  }
}

export { getUserJobList }
